import { useEffect, useRef, useState } from "react";
import { postData, useGetData } from "../../services/api/api-tools";
import LogoPerception from '../../assets/images/logos/logo-blue-black.png';
import LogoRenault from '../../assets/images/logos/Renault_Logo.png';
import { useSocket } from "../../contexts/SocketContext";
import { useAlert } from "../../contexts/AlertContext";
import { Loader } from "../../components/loading/Loader";
import {
  CLIPS_TEXTS, LUBRICATION_TEXTS, PIPES_TEXTS,
  STEP_COLORS
} from "../../services/live-interface/renault-interface-service";
import ToggleSwitch from "../../components/toggle/ToggleSwitch";
import audioFileLubrication from '../../assets/sounds/lubrication_error.mp3';
import audioFilePipes from '../../assets/sounds/pipes_error.mp3';
import audioFileClips from '../../assets/sounds/clips_error.mp3';
import audioFileSuccess from '../../assets/sounds/success.mp3';

export const RenaultLivePage = () => {

  const { socket, subscribeToEvent, unsubscribeFromEvent, sendEvent } = useSocket();
  const { showAlert } = useAlert();

  const { data: patterns } = useGetData('patterns', `patterns`);

  const [selectedPattern, setSelectedPattern] = useState(null);
  const [isStarted, setIsStarted] = useState(true);
  const [currentData, setCurrentData] = useState({});
  const [showSynthesis, setShowSynthesis] = useState(false);

  const lockedData = useRef(false);

  const [soundEnabled, setSoundEnabled] = useState(false);

  /* Temporary useEffect to automatically use the first pattern */
  useEffect(() => {
    if (!patterns) return;
    if (patterns?.length === 0) return;
    setSelectedPattern(patterns[0]);
  }, [patterns]);

  const handleStart = () => {
    if(selectedPattern !== null)
      setIsStarted(true);

    /* Send pattern data to the engine */
    // sendEvent('selected_pattern', selectedPattern);
  };

  const resetInterface = () => {
    setCurrentData([]);
    lockedData.current = false;
    handleStart();
  };

  useEffect(() => {
    if (!isStarted) return;
    if (!socket) return;

    const handleReceivedData = (data) => {
      if (lockedData.current) return;
      console.log(data);
      setCurrentData(prevData => ({...prevData, ...data}));

      // Sound management
      if (data?.play_lubrication_error === 1) {
        if (soundEnabled) emitSoundLubrication();
      }
      else if (data?.play_pipes_error === 1) {
        if (soundEnabled) emitSoundPipes();
      }
      else if (data?.play_clips_error === 1) {
        if (soundEnabled) emitSoundClips();
      }
      else if (data?.play_success === 1) {
        if (soundEnabled) emitSoundSuccess();
      }
    };

    subscribeToEvent('current_data', handleReceivedData);

    return () => {
      unsubscribeFromEvent('current_data', handleReceivedData);
    };
  }, [socket, isStarted, soundEnabled]);

  const handleRaiseError = () => {
    console.log('New error raised.');
    postData('live_errors', {date: Math.floor(Date.now() / 1000), pattern: `/api/patterns/${selectedPattern?.id}`});
    showAlert('success', 'Le manquement a bien été remonté.')
  };

  const stopProcess = () => {
    lockedData.current = true;
    setShowSynthesis(true);
    setTimeout(resetInterface, 30000);
  };

  const soundLubricationRef = useRef(null);
  const emitSoundLubrication = () => {
    if (soundLubricationRef.current) soundLubricationRef.current.play();
  };
  const soundPipesRef = useRef(null);
  const emitSoundPipes = () => {
    if (soundPipesRef.current) soundPipesRef.current.play();
  };
  const soundClipsRef = useRef(null);
  const emitSoundClips = () => {
    if (soundClipsRef.current) soundClipsRef.current.play();
  };
  const soundSuccessRef = useRef(null);
  const emitSoundSuccess = () => {
    if (soundSuccessRef.current) soundSuccessRef.current.play();
  };

  return (
    <div className='h-full overflow-hidden bg-perception-black-500'>
      <div className='flex flex-col items-center justify-center w-full h-full'>
        {
          isStarted && selectedPattern !== null ?
            <div className="w-full h-full flex flex-col text-white text-3xl relative">
              {/* Lubrication block */}
              <div className="w-full h-full flex items-center justify-center p-8 gap-8">
                <div className={`w-2/3 h-2/3 flex justify-center items-center rounded-md overflow-auto text-center p-8
                  ${STEP_COLORS[currentData?.lubrication_state]}`
                }>
                  {LUBRICATION_TEXTS[currentData?.lubrication_state]}
                </div>
                <div className={`w-2/3 h-2/3 flex justify-center items-center rounded-md overflow-auto text-center p-8
                  ${STEP_COLORS[currentData?.pipes_state]}`
                }>
                  {PIPES_TEXTS[currentData?.pipes_state]}
                </div>
                <div className={`w-2/3 h-2/3 flex justify-center items-center rounded-md overflow-auto text-center p-8
                  ${STEP_COLORS[currentData?.clips_state]}`
                }>
                  {CLIPS_TEXTS[currentData?.clips_state]}
                </div>
              </div>

              {/* Logos */}
              <div className="h-1/6 flex justify-center items-center text-xl gap-4 text-black">
                <img src={LogoPerception} alt="logo-perception" className="max-w-[200px] max-h-[60px]" />
                x
                <img src={LogoRenault} alt="logo-LCA" className="max-w-[200px] max-h-[60px]" />
              </div>

              {/* Sound management */}
              <div className="absolute top-8 right-8 text-lg flex items-center gap-2">
                Avertisseur sonore
                <ToggleSwitch enabled={soundEnabled} setEnabled={setSoundEnabled} />
                <audio ref={soundLubricationRef} src={audioFileLubrication} />
                <audio ref={soundPipesRef} src={audioFilePipes} />
                <audio ref={soundClipsRef} src={audioFileClips} />
                <audio ref={soundSuccessRef} src={audioFileSuccess} />
              </div>
            </div>
            :
            <>
              <Loader category="transparent"/>
              {/*<h2 className='my-6 text-3xl font-semibold'>Choisir une gamme</h2>*/}
              {/*<div className='flex flex-col gap-4 w-80 '>*/}
              {/*  <InputSelect*/}
              {/*    className='py-3'*/}
              {/*    items={patterns}*/}
              {/*    onChange={(pattern) => setSelectedPattern(pattern)}*/}
              {/*    itemToString={(pattern) => pattern?.name}*/}
              {/*    placeholder='Choisir une gamme'*/}
              {/*    category='secondary'*/}
              {/*    autoComplete='off'*/}
              {/*  />*/}
              {/*</div>*/}
              {/*<div className='my-6'>*/}
              {/*  <Button type='submit' category='primary-btn' size='small' onClick={handleStart}>*/}
              {/*    Démarrer*/}
              {/*  </Button>*/}
              {/*</div>*/}
            </>
        }
      </div>
    </div>
  );
};
